import { TooltipOverlay } from "app/popleads/components/TooltipOverlay";
import CustomDrawer, { DrawerBody, DrawerContent, DrawerHeader } from "app/popleads/components/drawer/CustomDrawer";
import useDisclosure from "app/popleads/hooks/useDisclosure";
import React from "react";
import styles from "../../../popleads/assets/css/design_3.0/CustomDatePicker.module.scss";
import CommonDateFilter from "./components/deal-filters/CommonDateFilter";
import { connect } from "react-redux";
import * as trainingRedux from "../training/redux/trainingRedux";
import ButtonWithText from "app/popleads/components/ui-kit/Button";

const TrainersFilter = ({ trainerSelectedDate, setTrainerSelecedDate }) => {
    const { isOpen, onClose, onToggle } = useDisclosure();

    return (
        <>
            <TooltipOverlay placement="bottom" tooltip="Filters">
                <ButtonWithText
                    label="Open filters"
                    icon={"filter"}
                    buttonStyle="selectedOption"
                    variant="primary"
                    onClick={onToggle}
                ></ButtonWithText>
            </TooltipOverlay>
            <CustomDrawer position="right" size="md" open={isOpen} onClose={onClose}>
                <DrawerContent isLoading={false}>
                    <DrawerHeader onClose={onClose} sx={{ border: "none" }}>
                        <div>Filters</div>
                    </DrawerHeader>
                    <DrawerBody sx={{ paddingTop: 0 }}>
                        <CommonDateFilter
                            dateObject={trainerSelectedDate}
                            setSelectedDateObject={setTrainerSelecedDate}
                            className={`${styles.rdrDateRangePickerWrapper} mt-4 mb-8`}
                        />
                    </DrawerBody>
                </DrawerContent>
            </CustomDrawer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        trainerSelectedDate: state.training.trainerSelectedDate,
    };
};
const mapDispatchToProps = {
    ...trainingRedux.actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainersFilter);
